import React from "react";
import { Home, Scissors, Building2, Fuel } from "lucide-react";

const AUDIENCES = [
  { icon: Home, title: "Solar & inverter homes", desc: "Iron every morning without dimming the lights or draining the bank you charged all day." },
  { icon: Scissors, title: "Tailors & fashion designers", desc: "Crisp professional finishing that keeps working when the grid doesn't." },
  { icon: Building2, title: "Small businesses", desc: "Laundries, boutiques and guest houses — lower power bills on every pressed piece." },
  { icon: Fuel, title: "Off-grid & generator homes", desc: "Light enough for a small gen. Less fuel burned for the same crisp result." },
];

export default function AudienceSection() {
  return (
    <section data-testid="audience-section" className="py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="eyebrow">Who it's for</div>
        <h2 className="display mt-4 max-w-3xl" style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)", color: "var(--ink)" }}>
          If your power comes with a plan, <span className="sunset-text">this is your iron</span>.
        </h2>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {AUDIENCES.map((a) => {
            const I = a.icon;
            return (
              <div key={a.title} className="p-8 glossy rounded-2xl">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-full" style={{ background: "var(--brand-tint)" }}>
                  <I size={22} color="var(--sun-orange)" strokeWidth={1.7} />
                </span>
                <h3 className="font-serif text-2xl mt-6" style={{ color: "var(--ink)" }}>{a.title}</h3>
                <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>{a.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
